/**
 * Maps API / axios errors to user-facing copy for restaurant bootstrap.
 */
export function getRestaurantFetchErrorMessage(error) {
    if (!error) {
        return "We couldn't load this restaurant. Please try again.";
    }

    const responseMessage =
        error.response?.data?.message ||
        error.response?.data?.Message ||
        error.response?.data?.error;

    if (typeof responseMessage === "string" && responseMessage.trim()) {
        return responseMessage.trim();
    }

    if (error.response?.status === 404) {
        return "This restaurant could not be found. Check the link and try again.";
    }

    if (error.response?.status >= 500) {
        return "The server is temporarily unavailable. Please try again in a moment.";
    }

    const msg = typeof error.message === "string" ? error.message : "";
    const lower = msg.toLowerCase();

    if (
        lower.includes("network error") ||
        lower.includes("network request failed") ||
        error.code === "ERR_NETWORK" ||
        (!error.response && error.request)
    ) {
        return "We couldn't connect to the server. Check your internet connection and try again.";
    }

    if (lower.includes("timeout") || error.code === "ECONNABORTED") {
        return "The request took too long. Please try again.";
    }

    if (msg.trim()) {
        return msg.trim();
    }

    return "We couldn't load this restaurant. Please try again.";
}
